import { pipePromise, handleStatuses } from 'utils';

import { Api } from './constants';

export const fetchArtsets = pipePromise(
  (options) => {
    const { token, publisherId } = options;

    return fetch(Api.FetchArtsets(), {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-appinapp-publisherid': publisherId,
      },
    });
  },
  handleStatuses(),
  (response) => response.json()
);

export const createArtset = pipePromise(
  (data, options) => {
    const { token, publisherId } = options;

    return fetch(Api.CreateArtset(), {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-appinapp-publisherid': publisherId,
      },
      body: JSON.stringify({
        Name: '',
        Labels: [],
        Products: [],
        Configuration: {
          ArtistName: data.artistName,
        },
        Images: [],
      }),
    });
  },
  handleStatuses(),
  (response) => response.text()
);

export const updateArtset = pipePromise(
  (artset, options) => {
    const { token, publisherId } = options;

    return fetch(Api.UpdateArtset(artset.Id), {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-appinapp-publisherid': publisherId,
      },
      body: JSON.stringify(artset),
    });
  },
  handleStatuses(),
  (response) => response.text()
);
